import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import seoConfig from "./SeoConfig";

const SEO = ({ customTitle, customDescription, customKeywords }) => {
  const location = useLocation();
  const path = location.pathname;

  // Get default SEO data for this path or use fallback
  const defaultSeo = seoConfig[path] || {
    title: "CLIF AI",
    description: "Career Advancement, Upskill & AI-Powered Career Growth",
    keywords: "CLIF AI",
  };

  // Use custom values if provided, otherwise use defaults
  const title = customTitle || defaultSeo.title;
  const description = customDescription || defaultSeo.description;
  const keywords = customKeywords || defaultSeo.keywords;

  useEffect(() => {
    // Manually update meta tags
    document.title = title;
    document
      .querySelector('meta[name="description"]')
      ?.setAttribute("content", description);
    document
      .querySelector('meta[name="keywords"]')
      ?.setAttribute("content", keywords);
  }, [location.pathname, title, description, keywords]);

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={window.location.href} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
};

export default SEO;
